import { render, staticRenderFns } from "./AuthDropdownItem.vue?vue&type=template&id=a774f786&scoped=true"
import script from "./AuthDropdownItem.vue?vue&type=script&lang=js"
export * from "./AuthDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a774f786",
  null
  
)

export default component.exports